var Vendd = (function (Vendd) {
	'use strict';

	Vendd.Installments = (function (Installments) {

		Installments.Messages = (function (Messages) {

			Messages.GetInstallmentsData = function (totalCost, productCost, preferredPaymentMethodId, productId, productVariantId) {
				Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Installments.Messages.GetInstallmentsData', {
					totalCost: totalCost,
					productCost: productCost,
					preferredPaymentMethodId: parseInt(preferredPaymentMethodId),
					productId: productId,
					productVariantId: productVariantId
				});
			};
			Messages.GetInstallmentsData.className = 'Vendd.Installments.Messages.GetInstallmentsData';

			Messages.GetInstallmentsDataSuccess = function (response) {
				Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Installments.Messages.GetInstallmentsDataSuccess', response);
			};
			Messages.GetInstallmentsDataSuccess.className = 'Vendd.Installments.Messages.GetInstallmentsDataSuccess';

			Messages.GetInstallmentsDataFailed = function (response) {
				Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Installments.Messages.GetInstallmentsDataFailed', response);
			};
			Messages.GetInstallmentsDataFailed.className = 'Vendd.Installments.Messages.GetInstallmentsDataFailed';

			return Messages;

		})(Installments.Messages || {});

		return Installments;

	})(Vendd.Installments || {});

	return Vendd;

})(Vendd || {});